import { createContext } from 'react';

const GlobalContext = createContext({
  company: {},
  setcompany: () => {},

  events: [],
  setEvents: () => {},

  organizations: [],
  setOrganizations: () => {},

  upcomingEvents: [],
  setUpcomingEvents: () => {},
});

export default GlobalContext;
